import { Box, Flex, Spacer, Text } from "@chakra-ui/react"
import { useRecoilValue } from "recoil"
import { UserAvatar } from "../../common/avatar"
import { OverlayModel } from "../../../recoil/atoms/overlay/types"
import { brandingSelector } from "../../../recoil/atoms/room"
import styled from "@emotion/styled"
import { CloseOverlayIcon } from "../../common/icons/close-overlay-icon"
import { useLocalUserType } from "../../../hooks/useLocalUserType"
import { convertMessage } from "../../../util/convert-message"

interface ChatOverlayProps extends OverlayModel {
  width?: number | string
  isSmallMainScreen: boolean
  isMobile: boolean
}

interface StyledProps {
  linkcolor: string
  isSmallMainScreen?: boolean
  isMobile?: boolean
}

const MessageText = styled.dd<StyledProps>`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: pre-wrap;
  font-size: ${({ isSmallMainScreen, isMobile }) =>
    isMobile ? "0.875rem" : isSmallMainScreen ? "0.75rem" : "0.875rem"};
  > a {
    color: ${({ linkcolor }) => `${linkcolor} !important`};
  }
`

const ChatOverlay = ({
  id,
  author,
  message,
  published,
  timestamp,
  width,
  isMobile,
  isSmallMainScreen,
}: ChatOverlayProps) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const { isModerator } = useLocalUserType()

  const showCLoseIcon = !isModerator

  if (published === false) return null
  return (
    <Flex
      id="overlay-chat"
      bgColor={
        roomStyles?.commentBackgroundColor
          ? roomStyles.commentBackgroundColor
          : "white"
      }
      maxWidth={width}
      key={`box-${id}`}
      p="0.30rem"
      borderRadius="0.6rem"
      borderLeftRadius="0"
      textOverflow="ellipsis"
      flexDirection="column"
      overflow="hidden"
      whiteSpace="nowrap"
    >
      {showCLoseIcon && <CloseOverlayIcon isMobile={isMobile} />}
      <Flex
        textColor={
          roomStyles?.commentTextColor ? roomStyles.commentTextColor : "inherit"
        }
        paddingRight={showCLoseIcon ? "27px" : null}
        maxW="100%"
      >
        <Box>
          <UserAvatar
            name={author?.name}
            size="xs"
            avatar={author?.avatar}
            avatarStyle={{ width: "1.5rem", height: "1.5rem" }}
            src={author?.avatar}
            colorDisk={author?.color}
          />
        </Box>
        <Box pl="0.33rem">
          <Text
            fontWeight={isMobile ? "600" : "600"}
            fontSize={
              isMobile ? "0.75rem" : isSmallMainScreen ? "0.75rem" : "0.75rem"
            }
            textOverflow="ellipsis"
            overflow="hidden"
            maxWidth={showCLoseIcon ? `calc(${width}px - 1.5rem - 32px)` : null}
          >
            {author?.name}
          </Text>
        </Box>
        <Spacer />
        <Box></Box>
      </Flex>
      <Flex
        textAlign="left"
        px="1.865rem"
        wordBreak="break-word"
        paddingRight="0.3rem"
        textColor={
          roomStyles?.commentTextColor ? roomStyles.commentTextColor : "inherit"
        }
        /*  fontFamily={
          roomStyles?.commentFontFamily
            ? roomStyles.commentFontFamily
            : "inherit"
        } */
      >
        <MessageText
          linkcolor={
            roomStyles?.commentTextColor
              ? roomStyles.commentTextColor
              : "inherit"
          }
          isMobile={isMobile}
          isSmallMainScreen={isSmallMainScreen}
          /*  fontSize="sm"
          textOverflow="ellipsis"
          overflow="hidden"
          whiteSpace="nowrap" */
          /* lineHeight={2} */
        >
          {convertMessage(message)}
        </MessageText>
      </Flex>
    </Flex>
  )
}
export default ChatOverlay
